import {IUserDataNormalizedPublic, IUserProfile, IUserProfileBase} from "./define";

export interface IUserTokenData {
	token: string;
	app: string;
	created: Date;
}

export interface IUserDocument<IProfile extends IUserProfileBase> extends IUserDataNormalizedPublic<IProfile>, DeprecatedProperties {
	_id: string;
	
	updatedAt: Date;
	createdAt: Date;
	__v: number;
	
	services: {
		password?: {
			bcrypt: string;
		};
		userCenter?: IUserTokenData[];
		resume?: {};
		facebook?: any;
		twitter?: any;
		weibo?: any;
		weixin?: any;
	};
}

export type IUserDocumentServer = IUserDocument<IUserProfile>;

export interface DeprecatedProperties {
	/** @deprecated */
	roles: any;
	/** @deprecated */
	emails?: {
		address: string;
		verified: boolean;
		provides?: string;
	}[];
}
